module.exports = __webpack_public_path__ + "static/media/ecolab.6e196828.jpg";